import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';
import { N0, N30A } from '@atlaskit/theme/colors';
var getSpacing = function getSpacing(spacing) {
  return spacing === 'comfortable' ? "var(--ds-space-300, 24px)" : "var(--ds-space-200, 16px)";
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
export var TabWrapper = styled.div(function (props) {
  return {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginLeft: getSpacing(props.spacing),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginRight: getSpacing(props.spacing)
  };
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var WaypointWrapper = styled.div({
  margin: "0 ".concat("var(--ds-space-300, 24px)"),
  flexGrow: 1,
  display: 'flex',
  flexDirection: 'column'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
export var TabListStickyHeader = styled.header(function (props) {
  return _objectSpread({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    paddingLeft: getSpacing(props.spacing),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    paddingRight: getSpacing(props.spacing)
  }, props.isSticky && {
    position: 'sticky',
    zIndex: 8,
    top: "".concat(props.top || 0, "px"),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingTop: "var(--ds-space-200, 16px)",
    backgroundColor: "var(--ds-surface, ".concat(N0, ")"),
    boxShadow: "0px ".concat("var(--ds-space-negative-025, -2px)", " 0px ", "var(--ds-border, ".concat(N30A, ")"), " inset"),
    '-webkit-box-shadow': "0px ".concat("var(--ds-space-negative-025, -2px)", " 0px ", "var(--ds-border, ".concat(N30A, ")"), " inset"),
    '-moz-box-shadow': "0px ".concat("var(--ds-space-negative-025, -2px)", ",\n    ) 0px ", "var(--ds-border, ".concat(N30A, ")"), " inset")
  });
});